export default __webpack_public_path__ + "static/media/PFSquareSansProBold_35480.9901a249.ttf";